import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
interface Props {
  onNext: () => void;
}
const data = [{
  label: 'Proof that momentum is real',
  value: 34,
  icon: '🚀'
}, {
  label: 'Stronger connection',
  value: 27,
  icon: '🤝'
}, {
  label: 'More optimism',
  value: 18,
  icon: '☀️'
}, {
  label: 'Clear direction',
  value: 14,
  icon: '🧭'
}, {
  label: 'A reason to feel proud',
  value: 7,
  icon: '🏆'
}];
export const Screen4Reveal = ({
  onNext
}: Props) => {
  const [revealed, setRevealed] = useState(false);
  useEffect(() => {
    const t = setTimeout(() => setRevealed(true), 600);
    return () => clearTimeout(t);
  }, []);
  return <div className="relative w-full h-full bg-slate-950 overflow-hidden flex flex-col" data-id="element-355">
      <div className="absolute inset-0 bg-gradient-to-tr from-red-950/30 via-slate-950 to-slate-950" data-id="element-356" />
      <div className="absolute top-0 right-0 w-64 h-64 bg-red-700/20 rounded-full blur-[80px]" data-id="element-357" />

      <div className="relative z-10 flex-1 flex flex-col p-8 pt-16" data-id="element-358">
        <motion.span initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} className="text-[10px] tracking-[0.3em] uppercase text-red-500 font-semibold mb-4" data-id="element-359">
          04 — Peer Reveal
        </motion.span>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6
      }} className="text-2xl font-bold text-white leading-tight mb-2" data-id="element-360">
          Here’s what your <span className="text-red-500" data-id="element-361">colleagues</span> are
          feeling.
        </motion.h2>
        <p className="text-sm text-slate-400 mb-8" data-id="element-362">
          Live results · 1,247 responses
        </p>

        <div className="flex-1 space-y-4" data-id="element-363">
          {data.map((item, i) => <motion.div key={item.label} initial={{
          opacity: 0,
          x: -20
        }} animate={{
          opacity: 1,
          x: 0
        }} transition={{
          delay: 0.3 + i * 0.15,
          duration: 0.5
        }} data-id="element-364">
              <div className="flex items-center justify-between mb-2" data-id="element-365">
                <div className="flex items-center space-x-2" data-id="element-366">
                  <span className="text-lg" data-id="element-367">{item.icon}</span>
                  <span className="text-sm text-white font-medium" data-id="element-368">
                    {item.label}
                  </span>
                </div>
                <motion.span initial={{
              opacity: 0
            }} animate={{
              opacity: revealed ? 1 : 0
            }} transition={{
              delay: 0.4 + i * 0.15
            }} className={`text-sm font-bold ${i === 0 ? 'text-red-500' : 'text-slate-300'}`} data-id="element-369">
                  {item.value}%
                </motion.span>
              </div>
              <div className="h-2 bg-slate-800/60 rounded-full overflow-hidden" data-id="element-370">
                <motion.div initial={{
              width: 0
            }} animate={{
              width: revealed ? `${item.value * 2.5}%` : 0
            }} transition={{
              delay: 0.4 + i * 0.15,
              duration: 0.9,
              ease: 'easeOut'
            }} className={`h-full rounded-full ${i === 0 ? 'bg-gradient-to-r from-red-500 to-red-600' : 'bg-slate-600'}`} data-id="element-371" />
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: revealed ? 1 : 0,
        y: revealed ? 0 : 10
      }} transition={{
        delay: 1.5
      }} className="bg-slate-900/60 border border-red-500/20 rounded-2xl p-4 mt-6 mb-6" data-id="element-372">
          <p className="text-sm text-white font-medium italic" data-id="element-373">
            “Momentum matters more than messaging.”
          </p>
        </motion.div>

        <button onClick={onNext} className="w-full bg-red-600 hover:bg-red-500 text-white font-semibold py-4 rounded-2xl flex items-center justify-center space-x-2 transition-all active:scale-[0.98]" data-id="element-374">
          <span data-id="element-375">Next</span>
          <ArrowRight className="w-5 h-5" data-id="element-376" />
        </button>
      </div>
    </div>;
};